import React, {Component} from 'react';
import {Chart} from 'chart.js';


export default class BarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.state = {
            labels: this.props.data.map(d => d.label),
            datasets: [{
              label: this.props.title,
              data: this.props.data.map(d => d.value),
              backgroundColor: this.props.color
            }]
          };
    }

    componentDidMount() {
        this.myChart = new Chart(this.chartRef.current, {
          type: 'line',
          data: {
            labels: this.props.data.map(d => d.label),
            datasets: [{
              label: this.props.title,
              data: this.props.data.map(d => d.value),
              backgroundColor: this.props.color
            }]
          }
        });
      }

    render(){
        return (
            <canvas className="my-4" id="myChart" width="900" height="380" ref={this.chartRef}></canvas>
        )
    }
}
